import { AddressWeb } from "./web";
import { AddressBlockProps } from "./types";

export function AddressWebEditor(props: AddressBlockProps) {
  return <AddressWeb {...props} />;
}
